import $ from 'jquery';

const $caseStudiesBlocks = $( '.js-case-studies' );
$caseStudiesBlocks.each( function () {
	const $block = $( this );
	const $loadMoreBtn = $block.find( '.js-case-studies__load-more-btn' );
	const $row = $block.find( '.js-case-studies__row' );
	let xhr;

	$block.on( 'click', '.js-case-studies__load-more-btn', function ( e ) {
		e.preventDefault();

		if ( xhr ) {
			// ajax request already in progress
			return;
		}

		const currentPage = $block.data( 'current-page' ) || 0;
		// $loadMoreBtn.addClass( 'c-link-load--disabled' );

		xhr = $.ajax( {
			url: window.designstudio.ajaxUrl,
			data: {
				action: 'designstudio_load_more_case_studies',
				designstudio_page: currentPage + 1,
				designstudio_posts_per_page: 6,
			},
			dataType: 'json',
			success: function( data ) {
				$block.data( 'current-page', data.page );
				$( data.data ).hide().appendTo( $row ).fadeIn();

				if ( ( data.page + 1 ) < Math.ceil( data.found_posts / 6 ) ) {
					// has more results
				} else {
					// no more results
					$loadMoreBtn.css( 'display', 'none' );
				}
			},
			error: function() {
				// console.log( 'error' );
			},
			complete: function () {
				// $loadMoreBtn.removeClass( 'c-link-load--disabled' );
				xhr = undefined;
			}
		} );
	} );
} );
